<template>
    <v-container fluid>
        <v-card class="pa-4">
            <v-card-title class="text-h5 mb-4">
                Типы колонок биллинга
            </v-card-title>

            <v-data-table :headers="headers" :items="billingKinds" :loading="loading" loading-text="Загрузка данных..."
                no-data-text="Нет данных..." class="elevation-1">
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-space-between">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="primary" v-bind="attrs" v-on="on" @click="editItem(item)">
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <span>Изменить</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="red" v-bind="attrs" v-on="on" @click="deleteItem(item)">
                                    mdi-delete
                                </v-icon>
                            </template>
                            <span>Удалить</span>
                        </v-tooltip>
                    </div>
                </template>
            </v-data-table>
            <!-- место для кнопки добавить -->
            <v-sheet height="64" />
            <!-- кнопка добавить -->
            <v-btn v-if="canAdd" bottom right color="primary" dark fab fixed to="/settings/billingVids/add">
                <v-icon class="white--text">
                    mdi-plus
                </v-icon>
            </v-btn>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'BillingKinds',
    data() {
        return {
            billingKinds: [],
            loading: false,
            headers: [
                { text: 'ID', value: 'id', align: 'start', sortable: true },
                { text: 'Название', value: 'name', sortable: true },
                { text: 'Действия', value: 'actions', sortable: false, align: 'center' }
            ]
        }
    },
    async created() {
        await this.loadData();
    },
    methods: {
        async loadData() {
            this.loading = true;
            try {
                const response = await this.axios.get('/billing/bill-column-vids');
                this.billingKinds = response.data;
            } catch (error) {
                console.error('Error loading billing kinds:', error);
                alert('Произошла ошибка при загрузке данных');
            } finally {
                this.loading = false;
            }
        },
        editItem(item) {
            // Implement edit functionality
            console.log('Edit item:', item);
            // Example: this.$router.push(`/billing-kinds/edit/${item.id}`);
        },
        async deleteItem(item) {
            if (confirm(`Удалить тип "${item.name}"?`)) {
                try {
                    await this.axios.delete(`/billing/bill-column-vids/${item.id}`);
                    await this.loadData(); // Reload data after deletion
                    alert('Тип успешно удален');
                } catch (error) {
                    console.error('Error deleting item:', error);
                    alert('Произошла ошибка при удалении');
                }
            }
        }
    },
    computed: {
        canAdd: function () {
            return this.$store.state.auth.user.role !== "Клиент" && this.$store.state.auth.user.role !== "Кладовщик"
        }
    }
}
</script>